import { render, staticRenderFns } from "./KeywordsSittings.vue?vue&type=template&id=67ad295b&"
import script from "./KeywordsSittings.vue?vue&type=script&lang=js&"
export * from "./KeywordsSittings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports